import { createElement, type CSSProperties, type ReactNode } from 'react';
import { useReveal, type RevealVariant } from '../../hooks/useReveal';

type Tag = 'div' | 'section' | 'article' | 'header' | 'figure' | 'li' | 'ul' | 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'blockquote' | 'dl';

/**
 * Wraps content in an element that fades up the first time it scrolls into view.
 *   <Reveal>…</Reveal>                         fade + 22px rise
 *   <Reveal variant="image" className="overflow-hidden rounded-[10px]"><img …/></Reveal>   unveil + slow zoom-out
 *   {items.map((x, i) => <Reveal as="li" delay={i * 90}>…</Reveal>)}                 staggered list
 */
export function Reveal({ as = 'div', variant = 'up', delay = 0, className, style, children, id }: {
  as?: Tag; variant?: RevealVariant; delay?: number; className?: string; style?: CSSProperties; children?: ReactNode; id?: string;
}) {
  const ref = useReveal<HTMLElement>(variant, delay);
  return createElement(as, { ref, className, style, id }, children);
}
